var React = require('react');

function AwsLambda (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"AWS-Lambda"),React.createElement("g",{"key":1},React.createElement("g",{"data-name":"Icon Test"},[React.createElement("path",{"className":"cls-2","d":"M60.5,62.5H48.18a1,1,0,0,1-.9-.57L29.86,25.5H22.49a1,1,0,0,1-1-1v-11a1,1,0,0,1,1-1H37.89a1,1,0,0,1,.9.57L56.13,49.5H60.5a1,1,0,0,1,1,1v11A1,1,0,0,1,60.5,62.5Zm-11.69-2H59.5v-9h-4a1,1,0,0,1-.9-.57L37.26,14.5H23.5v9h7a1,1,0,0,1,.9.57Z","key":0}),React.createElement("path",{"className":"cls-2","d":"M27.48,62.5h-13a1,1,0,0,1-.85-.47,1,1,0,0,1-.05-1L27.18,32.62a1,1,0,0,1,.9-.57h0a1,1,0,0,1,.9.56L35.49,46a1,1,0,0,1,0,.87l-7.1,15A1,1,0,0,1,27.48,62.5Zm-11.4-2H26.85l6.63-14L28.09,35.35Z","key":1})]))]);
}

AwsLambda.defaultProps = {"viewBox":"0 0 75 75"};

module.exports = AwsLambda;

AwsLambda.default = AwsLambda;
